import { actions } from "./action-list";

export function operatorConfigCity(value) {
  return {
    type: actions.OPERATOR_CONFIG_CITY,
    value,
  };
}

export function operatorConfigEdit(value) {
  return {
    type: actions.OPERATOR_CONFIG_EDIT,
    value,
  };
}

export function fetchOperatorConfig(value) {
  return {
    type: actions.FETCH_OPERATOR_CONFIG,
    value,
  };
}

